import { Link } from "react-router-dom";
import img1 from "./1.gif";
import img2 from "./2.gif";
import img3 from "./3.gif";
import img4 from "./4.jpg";
import img5 from "./5.png";
import img6 from "./6.jpeg";

export const Gallery = () => {
  return (
    <div className="home gallery">
      <div className="gallery">
        <div className="canvas">
          <img className="canvas img" src={img1} alt="" />

          <Link
            to={{ pathname: "https://objkt.com/asset/hicetnunc/484150" }}
            target="_blank"
          >
            <p>web</p>
          </Link>
        </div>

        <div className="canvas">
          <img className="canvas img" src={img2} alt="" />
          <p>half</p>
        </div>

        <div className="canvas">
          <img className="canvas img" src={img3} alt="" />
          <Link
            to={{ pathname: "https://objkt.com/asset/hicetnunc/513747" }}
            target="_blank"
          >
            <p>projektion</p>
          </Link>
        </div>

        <div className="canvas">
          <img className="canvas img" src={img4} alt="" />
          <p>scapes</p>
        </div>

        <div className="canvas">
          <img className="canvas img" src={img5} alt="" />
          <p>aa185</p>
        </div>

        <div className="canvas">
          <img className="canvas img" src={img6} alt="" />
          <p>dali</p>
        </div>
      </div>
    </div>
  );
};
